import React from 'react';
import PropTypes from 'prop-types';
import SvgText from 'components/svg-text';
import * as Orient from 'constants/orient';
import * as Tone from 'constants/tone';
import {getTranslate} from 'utils/attribute-util';
import Colors from 'common/constants/colors';
import styles from './index.css';

export default class HeatmapTooltip extends React.Component {
  static propTypes = {
    anchorLength: PropTypes.number,
    anchorWidth: PropTypes.number,
    color: PropTypes.string,
    description: PropTypes.string,
    height: PropTypes.number,
    orient: PropTypes.oneOf(Object.values(Orient)),
    padding: PropTypes.number,
    title: PropTypes.string,
    tone: PropTypes.oneOf(Object.values(Tone)),
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    anchorLength: 12,
    anchorWidth: 20,
    color: '',
    description: '',
    height: 90,

    // TODO bottom, left, and right orientations
    orient: Orient.TOP,
    padding: 16,
    title: '',
    tone: Tone.LIGHT,
    width: 180,
    x: 0,
    y: 0,
  };

  getBackgroundPath(width, height, anchorLength, anchorWidth, orient) {
    if (orient === Orient.TOP) {
      const rectHeight = height - anchorLength;
      return [
        'M 0 0',
        `H ${width}`,
        `V ${rectHeight}`,
        `L ${width / 2 + anchorWidth / 2} ${rectHeight}`,
        `L ${width / 2} ${height}`,
        `L ${width / 2 - anchorWidth / 2} ${rectHeight}`,
        'H 0',
        'Z',
      ].join(' ');
    }
    return [];
  }

  getContainerPosition(width, height) {
    return {
      containerX: -width / 2,
      containerY: -height,
    };
  }

  getStyleForTone(tone) {
    return tone === Tone.DARK
      ? {
          color: Colors.white,
          fill: Colors.gray700,
        }
      : {
          color: Colors.blackModal,
          fill: Colors.white,
          stroke: Colors.gray500,
        };
  }

  render() {
    const style = this.getStyleForTone(this.props.tone);
    const backgroundPath = this.getBackgroundPath(
      this.props.width,
      this.props.height,
      this.props.anchorLength,
      this.props.anchorWidth,
      this.props.orient,
    );
    const {containerX, containerY} = this.getContainerPosition(
      this.props.width,
      this.props.height,
    );
    const containerTranslate = getTranslate(containerX, containerY);
    const contentTranslate = getTranslate(
      this.props.padding,
      this.props.padding,
    );
    const translate = getTranslate(this.props.x, this.props.y);
    return (
      <g className={styles.HeatmapTooltip} transform={translate}>
        <g
          className={styles.HeatmapTooltipContainer}
          transform={containerTranslate}>
          <g className={styles.HeatmapTooltipBackground}>
            <path d={backgroundPath} style={style} />
          </g>
          <g
            className={styles.HeatmapTooltipContent}
            transform={contentTranslate}>
            <rect
              fill={this.props.color}
              height={10}
              stroke={
                this.props.color === Colors.white ? Colors.gray500 : 'none'
              }
              width={20}
              y={4}
            />
            <SvgText
              className={styles.HeatmapTooltipTitle}
              style={{
                fill: style.color,
              }}
              text={this.props.title}
              x={28}
            />
            <SvgText
              className={styles.HeatmapTooltipDescription}
              style={{
                fill: style.color,
              }}
              text={this.props.description}
              y={28}
            />
          </g>
        </g>
      </g>
    );
  }
}
